// Device detection utility
// Rileva se l'utente sta usando uno smartphone in base a user agent e larghezza schermo

const MOBILE_UA_REGEX = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile/i;

// iPad-like tablets: consideriamoli desktop (schermo grande)
export function isMobileDevice() {
  if (typeof window === 'undefined') return false;
  const ua = navigator.userAgent || '';
  const uaIsMobile = MOBILE_UA_REGEX.test(ua);
  const narrowScreen = window.innerWidth < 768;
  // Un utente è "mobile" se il UA lo indica OPPURE se lo schermo è stretto (< 768px)
  return uaIsMobile || narrowScreen;
}

// Hook React per reattività al resize (opzionale)
import { useState, useEffect } from 'react';
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(isMobileDevice());
  useEffect(() => {
    const onResize = () => setIsMobile(isMobileDevice());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return isMobile;
}
